"use client";

import { useAuthenticatedQuery } from "./use-authenticated-query";
import { CallScoringService, type CallScoringDraftEmailResponse } from "@/api-client/call-scoring";
import { getQueryKey, QUERY_KEYS } from "@/lib/query-keys";

interface UseCallScoringDraftEmailParams {
  meetingId: number | null | undefined;
  enabled?: boolean;
}

export function useCallScoringDraftEmail({
  meetingId,
  enabled = true,
}: UseCallScoringDraftEmailParams) {
  const queryKey = getQueryKey(QUERY_KEYS.CALL_SCORING_DRAFT_EMAIL, {
    meetingId: meetingId ?? 0,
  });

  return useAuthenticatedQuery<CallScoringDraftEmailResponse>({
    queryKey: [queryKey],
    enabled: enabled && Boolean(meetingId),
    staleTime: 60 * 1000,
    retry: false,
    queryFn: () => {
      if (!meetingId) throw new Error("Meeting ID is required");
      return CallScoringService.getDraftEmail(meetingId);
    },
  });
}
